import Vue from "vue";
import App from "./App";
import Dataset from "../static/pomm";
import { ConfigPlugin } from "../static/pomm.conf";
import { ColorServicePlugin } from "./ColorService";
import { DataServicePlugin } from "./DataService";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes, faPalette } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add([faTimes, faPalette]);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(DataServicePlugin, { Dataset });
Vue.use(ColorServicePlugin);
Vue.use(ConfigPlugin);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: { App },
  data: {
    bus: new Vue()
  },
  template: '<App :bus="bus" />'
});
